import gql from 'graphql-tag';
import { sessionReportQuestionStepFieldsFragment } from './sessionReportQuestionStepFieldsFragment';
import { sessionReportScoreFieldsFragment } from './sessionReportScoreFieldsFragment';

export const sessionReportQuestionFieldsFragment = gql`
  fragment AdminSessionReportQuestionFields on SessionReportQuestion {
    name
    score {
      ...AdminSessionReportScoreFields
    }
    steps {
      ...AdminSessionReportQuestionStepFields
    }
  }

  ${sessionReportScoreFieldsFragment}
  ${sessionReportQuestionStepFieldsFragment}
`;